import { render, staticRenderFns } from "./homePage6.vue?vue&type=template&id=5650b68b&scoped=true"
import script from "./homePage6.vue?vue&type=script&lang=js"
export * from "./homePage6.vue?vue&type=script&lang=js"
import style0 from "./homePage6.vue?vue&type=style&index=0&id=5650b68b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650b68b",
  null
  
)

export default component.exports